import { useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';
import Tab from 'components/Tabs/Tab';
import _ from 'lodash';
import PropTypes from 'prop-types';

const Tabs = ({ selected, onChange, tabs, actionPanel, className }) => {
  const [selectedTab, setSelectedTab] = useState(selected || 0);

  useEffect(() => {
    setSelectedTab(selected);
  }, [selected]);

  const handleTabClick = (index) => {
    if (index !== selectedTab) {
      onChange(index);
    }
  };

  return (
    <div className={`tabs-container d-flex flex-column ${className}`}>
      <div className="tabs-header d-flex flex-row align-items-center justify-content-between pr-3">
        <div className="tabs d-flex">
          {_.map(tabs, (tab, index) => {
            const content = (
              <div key={index}>
                <Tab
                  index={index}
                  disabled={tab.disabled}
                  selected={selectedTab === index}
                  onClick={() => handleTabClick(index)}
                >
                  {tab.label}
                </Tab>
              </div>
            );
            return tab.disabled ? (
              <Tooltip key={index} title={`${tab.label} está deshabilitado para este activo`}>
                {content}
              </Tooltip>
            ) : (
              content
            );
          })}
        </div>
        <div className="tabs-action-panel d-flex">
          {_.map(actionPanel, (button, index) => button)}
        </div>
      </div>
    </div>
  );
};

Tabs.propTypes = {
  selected: PropTypes.number,
  tabs: PropTypes.arrayOf(PropTypes.object),
  actionPanel: PropTypes.arrayOf(PropTypes.node),
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

Tabs.defaultProps = {
  selected: false,
  tabs: [],
  actionPanel: [],
  className: '',
};

export default Tabs;
